import { call, takeEvery } from 'redux-saga/effects';
import { ApplicationConstants } from 'constants/application';
import { request } from 'components/Fetch';

function* fetchApplicationList(action) {
  yield call(request({
    type: ApplicationConstants.FETCH_APPLICATION_LIST,
    method: 'GET',
    url: action.payload.url,
  }), action);
}

function* fetchOffersList(action) {
  yield call(request({
    type: ApplicationConstants.FETCH_FETCH_LIST,
    method: 'GET',
    url: action.payload.url,
  }), action);
}

function* fetchApplicationFilterList(action) {
  yield call(request({
    type: ApplicationConstants.FETCH_APPLICATION_FILTERS,
    method: 'GET',
    url: action.payload.url,
    payloadOnSuccess: data => ({
      filters: [
        ...data.filters[0].filters.splice(2),
      ],
    }),
  }), action);
}

function* downloadJSONFromPresign(action) {
  yield call(request({
    type: ApplicationConstants.DOWNLOAD_JSON_FROM_PRESIGN,
    method: 'GET',
    url: action.payload.url,
    payloadOnSuccess: data => ({
      filters: [
        ...data.filters[0].filters.splice(2),
      ],
    }),
  }), action);
}

function* updateApplication(action) {
  yield call(request({
    type: ApplicationConstants.PATCH_APPLICATION,
    method: 'PATCH',
    url: action.payload.url,
  }), action);
}

function* uploadDocuments(action) {
  yield call(request({
    type: ApplicationConstants.UPLOAD_DOCUMENTS,
    method: 'POST',
    url: action.payload.url,
  }), action);
}

function* getDocuments(action) {
  yield call(request({
    type: ApplicationConstants.GET_DOCUMENTS,
    method: 'GET',
    url: action.payload.url,
  }), action);
}

function* fetchMerchantDetail(action) {
  yield call(request({
    type: ApplicationConstants.FETCH_MERCHANT_DETAIL,
    method: 'GET',
    url: action.payload.url,
  }), action);
}

function* resendEmail(action) {
  yield call(request({
    type: ApplicationConstants.RESEND_EMAIL,
    method: 'POST',
    url: action.payload.url,
  }), action);
}

function* getStats(action) {
  yield call(request({
    type: ApplicationConstants.GET_STATS,
    method: 'GET',
    url: action.payload.url,
  }), action);
}

function* getRefundReasons(action) {
  yield call(request({
    type: ApplicationConstants.GET_REFUND_REASONS,
    method: 'GET',
    url: action.payload.url,
  }), action);
}
function* getFeatures(action) {
  yield call(request({
    type: ApplicationConstants.GET_FEATURES,
    method: 'GET',
    url: action.payload.url,
  }), action);
}

function* getActiveContract(action) {
  yield call(request({
    type: ApplicationConstants.GET_ACTIVE_CONTRACT,
    method: 'GET',
    url: action.payload.url,
  }), action);
}

function* refundRequest(action) {
  yield call(request({
    type: ApplicationConstants.REFUND_REQUEST,
    method: 'POST',
    url: action.payload.url,
  }), action);
}

function* getDepositRefunds(action) {
  yield call(request({
    type: ApplicationConstants.GET_DEPOSIT_REFUNDS,
    method: 'GET',
    url: action.payload.url,
  }), action);
}

function* getTestValuesData(action) {
  yield call(request({
    type: ApplicationConstants.GET_TEST_VALUES_DATA,
    method: 'GET',
    url: action.payload.url,
  }), action);
}

export default function* () {
  yield takeEvery(ApplicationConstants.FETCH_APPLICATION_LIST, fetchApplicationList);
  yield takeEvery(ApplicationConstants.FETCH_OFFERS_LIST, fetchOffersList);
  yield takeEvery(ApplicationConstants.FETCH_APPLICATION_FILTERS, fetchApplicationFilterList);
  yield takeEvery(ApplicationConstants.UPLOAD_DOCUMENTS, uploadDocuments);
  yield takeEvery(ApplicationConstants.GET_DOCUMENTS, getDocuments);
  yield takeEvery(ApplicationConstants.FETCH_MERCHANT_DETAIL, fetchMerchantDetail);
  yield takeEvery(ApplicationConstants.RESEND_EMAIL, resendEmail);
  yield takeEvery(ApplicationConstants.GET_STATS, getStats);
  yield takeEvery(ApplicationConstants.GET_FEATURES, getFeatures);
  yield takeEvery(ApplicationConstants.PATCH_APPLICATION, updateApplication);
  yield takeEvery(ApplicationConstants.GET_REFUND_REASONS, getRefundReasons);
  yield takeEvery(ApplicationConstants.GET_ACTIVE_CONTRACT, getActiveContract);
  yield takeEvery(ApplicationConstants.REFUND_REQUEST, refundRequest);
  yield takeEvery(ApplicationConstants.GET_DEPOSIT_REFUNDS, getDepositRefunds);
  yield takeEvery(ApplicationConstants.DOWNLOAD_JSON_FROM_PRESIGN, downloadJSONFromPresign);
  yield takeEvery(ApplicationConstants.GET_TEST_VALUES_DATA, getTestValuesData);
}



// WEBPACK FOOTER //
// ./src/sagas/applicationSaga.js